import { render } from "./xtx-bread-item.vue?vue&type=template&id=78e9338c"
import script from "./xtx-bread-item.vue?vue&type=script&lang=js"
export * from "./xtx-bread-item.vue?vue&type=script&lang=js"

import exportComponent from "D:\\hbuilderxpro\\jxshop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__